export default "__VITE_ASSET__BySgVyrX__"